import React from "react";
import { TBody } from "../styledEdit";
import Row from "./Row";

const Rows = ({
  rows,
  cols,
  setSettingsDraft,
  onChange,
  addRow,
  removeRow,
}) => {
  return (
    <TBody>
      {rows.map((row, rowIdx) => (
        <Row
          key={row.id}
          rowIdx={rowIdx}
          row={row}
          cols={cols}
          setSettingsDraft={setSettingsDraft}
          addRow={addRow}
          removeRow={removeRow}
          onChange={onChange}
        />
      ))}
    </TBody>
  );
};

export default Rows;
